
// For each form control, its name, default value, and whether or not
// its "within normal limits" checkbox is checked.
interface ControlInfo {
  default: any;
  wnl: boolean;
}

/**
 * An object of this class helps manage the setting of WNL (Within Normal Limits) boxes
 * in a form. The form often contains multiple controls, some of which have related
 * WNL boxes (see emr-input.component). The form then has a master WNL check box.
 * If `allWNL` is true, the master WNL check box is checked. If someWNL() returns true,
 * then the master WNL check box is in the "indeterminate" state.
 */
export class WnlManagerService {

  // an object indexed by unique control name, containing the default value for the
  // control, and the control's related WNL box's checked state.
  public controlColl: {
    [k: string]: ControlInfo
  } = {};

  /**
   * This control information is converted to an object for better look up.
   * @param controls an array of control information.
   */
  setControls(controls: { control: string; default: any; wnl: boolean }[]) {
    controls.forEach((c) => {
      this.controlColl[c.control] = {
        default: c.default,
        wnl: false,
      };
    });
  }

  // Boolean to store value of "All Within Normal Limits" checkbox
  allWNL = false;

  /**
   * updateAllWNL
   *
   * Sets allWNL to true if all wnl properties in the controlColl are true; otherwise,
   * allWNL is set to false.
   */
  updateAllWNL() {
    this.allWNL = Object.entries(this.controlColl).every(([propName, val]) => val.wnl);
  }

  /**
   * someWNL
   *
   * @returns boolean indicating whether or not the "WNL" options in
   * the controlColl are all true)
   */
  someWNL(): boolean {
    return Object.entries(this.controlColl).some(([propName, val]) => val.wnl) && !this.allWNL;
  }

  /**
   * setAllWNL
   *
   * @param checked boolean that represents whether the user checked the "All WNL" box or not
   *
   * Sets all "wnl" properties in the controlColl to the value of the "All WNL" box
   */
  setAllWNL(checked: boolean) {
    this.allWNL = checked;
    Object.entries(this.controlColl).forEach(([propName, val]) => val.wnl = checked);
  }
}
